const enum ButtonVariant {
  default = 'default',
  outline = 'outline',
  text = 'text',
  plain = 'plain',
}

export default ButtonVariant
